import React, { useEffect, useRef, useState } from "react";
import { Swiper } from "swiper/react";
import "swiper/modules/grid/grid.min.css";
import { Pagination, Navigation, Grid } from "swiper";

import { EMPTY_STRING } from "../../../constants";

const SliderWrapper = ({
  children,
  classes = EMPTY_STRING,
  spaceBetween = 10,
  sliderHeight = "auto",
  initialSlide = 0,
  showPagination = true,
  PrevIcon,
  NextIcon,
  prevButtonClass = EMPTY_STRING,
  nextButtonClass = EMPTY_STRING,
  modules,
  slidesPerView,
  gridRows = 1,
  paginationOptions = { dynamicBullets: true },
}) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [swiperReady, setSwiperReady] = useState(false);

  useEffect(() => {
    // Wait for refs to be available
    setSwiperReady(true);
    // eslint-disable-next-line
  }, []);

  // Trigger swiper update on children change
  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.update(); // recalculate layout
    }
  }, [children]);

  return (
    <div className="swiper-container w-full" style={{ position: "relative" }}>
      {swiperReady && (
        <Swiper
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          className={`mySwiper ${classes}`}
          slidesPerView={slidesPerView ? slidesPerView : "auto"}
          spaceBetween={spaceBetween}
          style={sliderHeight ? { height: `${sliderHeight}` } : {}}
          initialSlide={initialSlide}
          freeMode={true}
          pagination={
            showPagination
              ? {
                  ...paginationOptions,
                }
              : false
          }
          navigation={
            PrevIcon && NextIcon
              ? {
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }
              : true // use default navigation
          }
          grid={gridRows ? { rows: gridRows, fill: "row" } : undefined}
          onBeforeInit={(swiper) => {
            if (PrevIcon && NextIcon) {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
            }
          }}
          modules={
            modules ? [Pagination, Navigation, Grid] : [Pagination, Navigation]
          }
          centeredSlides={false}
          centerInsufficientSlides={true}
          loop={false}
        >
          {children}
        </Swiper>
      )}

      {/* Custom navigation arrows */}
      {PrevIcon && (
        <div ref={prevRef} className={`${prevButtonClass}`}>
          {PrevIcon && <PrevIcon />}
        </div>
      )}
      {NextIcon && (
        <div ref={nextRef} className={`${nextButtonClass}`}>
          {NextIcon && <NextIcon />}
        </div>
      )}
    </div>
  );
};

export default SliderWrapper;
